import React from "react";
import PropTypes from "prop-types";
import SingleEvent from "../SingleEvent";
import EventListHeader from "../EventListHeader";
import { Loader } from "../../index";
import CheckBox from "../UserInputs/Checkbox";
import v from "../../assets/imgs/check-box-v.png";

const emptyEvent = {
  commentType: "",
  seekTime: null,
  tagedUsers: "",
  position: ""
};
const defaultEvents = new Array(15).fill(emptyEvent);

const EventsList =
// React.forwardRef(
  (
    {
      events,
      isDesc,
      handleSort,
      isEmpty,
      isPaused,
      handleEventClick,
      playOnProgress,
      isLoading,
      className,
      handleChangeTime,
      checkedEventsIds,
      onEventCheckboxClick,
      onMarkAllEvents,
      shouldDisplayHeaderCheckbox,
      isCheckBoxActive,
      sortBy
    },
    // ref
  ) => {
    const isAllHighlightsChecked =
      !isLoading &&
      checkedEventsIds &&
      checkedEventsIds.length === events.length;
    return (
      <div className={`event-list ${className}`}>
        <div className="event-list__header-wrapper">
          {shouldDisplayHeaderCheckbox && isCheckBoxActive && (
            // eslint-disable-next-line
            <label className="event-list__header-wrapper__label"
              style={{width: isAllHighlightsChecked && "50px"}}
            >
              <div
                className="event-list__header-wrapper__check-box"
                style={{
                  transform: isAllHighlightsChecked && "translateX(0px)"
                }}
              >
                <CheckBox
                  id="header-checkbox"
                  name="header-checkbox"
                  checked={isAllHighlightsChecked}
                  onChange={onMarkAllEvents}
                >
                  {isAllHighlightsChecked && (
                    <img className="v-mark" src={v} alt="" />
                  )}
                </CheckBox>
              </div>
            </label>
          )}
          <EventListHeader isDesc={isDesc} handleSort={handleSort} sortBy={sortBy}/>
        </div>
        {isLoading ? (
          <div className="event-list__loading">
            <div className="event-list__loading__loader">
              <Loader height={120} width={120} type="spinningBubbles" />
              <p>Loading Breakdowns</p>
            </div>
            <div
              // ref={ref}
            className="event-list__single-event">
              {defaultEvents.map((event, index) => (
                <SingleEvent
                  key={event.id}
                  event={event}
                  handleEventClick={() => handleEventClick(event, index)}
                  playOnProgress={playOnProgress}
                  isPaused={isPaused}
                  isEmpty

                />
              ))}
            </div>
          </div>
        ) : null}
        <div
          // ref={ref}
          className="event-list__single-event">
          {events.map(event => (
            <div
              key={`parent${event.id}`}
              className="event-list__single-event__wrapper"
            >
              {/* eslint-disable */}
              <label
                className={`event-list__single-event__wrapper__label
                  ${!isCheckBoxActive ? 'event-list__single-event__wrapper__label--non-active' : ''}
                `}
                style={{
                  width:
                    checkedEventsIds &&
                    checkedEventsIds.includes(event.id) &&
                    "50px"
                }}
              >
                {/* eslint-enable */}
                <div
                  className={`event-list__single-event__wrapper__check-box
                    ${!isCheckBoxActive ? 'event-list__single-event__wrapper__check-box--non-active' : ''}`}
                  style={{
                    transform:
                      checkedEventsIds &&
                      checkedEventsIds.includes(event.id) &&
                      isCheckBoxActive &&
                      "translateX(0px)"
                  }}
                >
                  <CheckBox
                    id={`event${event.id}`}
                    name={`event${event.id}`}
                    checked={
                      checkedEventsIds && checkedEventsIds.includes(event.id)
                    }
                    onChange={() => onEventCheckboxClick(event.id)}
                  >
                    {checkedEventsIds &&
                      checkedEventsIds.includes(event.id) && (
                        <img className="v-mark" src={v} alt="" />
                      )}
                  </CheckBox>
                </div>
              </label>
              <SingleEvent
                key={event.id}
                isEmpty={isEmpty}
                isPaused={isPaused}
                event={event}
                handleEventClick={handleEventClick}
                playOnProgress={playOnProgress}
                handleChangeTime={handleChangeTime}
                hasDownload={isCheckBoxActive}
              />
            </div>
          ))}
        </div>
      </div>
    );
  }
// );

EventsList.propTypes = {
  events: PropTypes.array,
  handleEventClick: PropTypes.func,
  handleSort: PropTypes.func,
  isDesc: PropTypes.bool
};

EventsList.defaultProps = {
  events: defaultEvents,
  handleEventClick: () => {},
  handleSort: () => {},
  isDesc: true
};

export default EventsList;
